export default "__VITE_ASSET__4SLX9jhm__"